import { defineMessages } from 'react-intl';

const messages = defineMessages({
  social: {
    id: 'OKhRC6',
    defaultMessage: 'Share',
  },
  question1_title: {
    id: 'Y13iOu',
    defaultMessage: 'What is your primary industry?',
  },
  question1_opt1: {
    id: '3PREB4',
    defaultMessage: 'Energy and Utilities',
  },
  question1_opt2: {
    id: 'bh4rlK',
    defaultMessage: 'Government',
  },
  question1_opt3: {
    id: 'z3FEm2',
    defaultMessage: 'Manufacturing',
  },
  question1_opt4: {
    id: 'XLHNRm',
    defaultMessage: 'Oil and Gas',
  },
  question1_opt5: {
    id: 'b+UzFA',
    defaultMessage: 'Travel and Transportation',
  },
  question1_opt6: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  question1_opt2_tooltipInfo: {
    id: 'bAUWF+',
    defaultMessage:
      'Agencies and educational institutions organized at various levels. If your company serves multiple industries, choose the one that reflects your needs the most.',
  },
  question1_opt3_tooltipInfo: {
    id: '5uDaiK',
    defaultMessage:
      'Different segments that involve the production of goods such as automotive, electronics, industrial products, pharmaceuticals.',
  },
  question1_opt5_tooltipInfo: {
    id: 'iuVOEL',
    defaultMessage:
      'Segments such as aviation, ground transportation, rail, maritime, logistics and freight services.',
  },
  question2_title: {
    id: 'BXQFjU',
    defaultMessage: 'Which business challenge do you want to address?',
  },
  question2_opt2: {
    id: 'V8Llv1',
    defaultMessage: 'Asset reliability',
  },
  question2_opt2_info: {
    id: 'dWLyyr',
    defaultMessage:
      'Optimize asset performance, prevent failures, and extract valuable insights to inform data-driven decision-making and improve overall asset reliability.',
  },
  question2_opt4: {
    id: 'uBBk1/',
    defaultMessage: 'Sustainable asset management',
  },
  question2_opt4_info: {
    id: 'taddp3',
    defaultMessage:
      'Balance the need for asset reliability, performance, and maintenance with the imperative to minimize environmental impact and maximize long-term value.',
  },
  question2_opt1: {
    id: 'nS1hx6',
    defaultMessage: 'Asset inspection',
  },
  question2_opt1_info: {
    id: 'hjFNOz',
    defaultMessage:
      'Improve maintenance and quality inspections, increase first-time fix rates, retain workforce, and avoid operational disruption.',
  },
  question2_opt3: {
    id: 'nvl3sB',
    defaultMessage: 'Maintenance management',
  },
  question2_opt3_info: {
    id: 'hS3xRz',
    defaultMessage:
      'Automate workflows, optimize maintenance schedules, and improve maintenance efficiency to ensure assets are operating at peak performance.',
  },
  question2_opt5: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  select_text: {
    id: 'GXt1ln',
    defaultMessage: 'Select all that apply.',
  },
  question3_title: {
    id: 'RhURYa',
    defaultMessage: 'What is your current asset management solution?',
  },
  question3_opt1: {
    id: 'E7oe4u',
    defaultMessage: 'Computerized Maintenance Management System (CMMS)',
  },
  question3_opt2: {
    id: 'Kz9IOe',
    defaultMessage: 'Asset Performance Management (APM)',
  },
  question3_opt3: {
    id: 'HnKqGB',
    defaultMessage: 'Enterprise Asset Management (EAM)',
  },
  question3_opt4: {
    id: 'fd/DO3',
    defaultMessage: 'Spreadsheets',
  },
  question3_opt5: {
    id: 'f7/blw',
    defaultMessage: 'Reliability-Centered Maintenance (RCM)',
  },
  question3_opt6: {
    id: 'cVMW7v',
    defaultMessage: 'Visual Inspection',
  },
  question3_opt7: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  thank_text: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thank_desc: {
    id: 'UqtOxr',
    defaultMessage:
      'Thank you for requesting a live demo to see IBM Maximo Application Suite in action. A member of our team will be in contact with you shortly.',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  return_assessment: {
    id: '/YY0KV',
    defaultMessage: 'Return to assessment',
  },
  demo_btn_text: {
    id: 'xSsVfT',
    defaultMessage: 'Book a live demo',
  },
  progress_step1_text: {
    id: 'Cl8+UF',
    defaultMessage: 'Primary industry',
  },
  progress_step2_text: {
    id: 'IUdSXt',
    defaultMessage: 'Business challenge',
  },
  progress_step3_text: {
    id: 'A8QzWU',
    defaultMessage: 'Current strategy',
  },
  progress_step4_text: {
    id: 'yaMHMB',
    defaultMessage: 'Results',
  },
  multi_resp_text: {
    id: 'pL86MS',
    defaultMessage: 'Multiple responses selected',
  },
  result_text: {
    id: 'Bkxa6g',
    defaultMessage: 'Based on your selections, we recommend this content',
  },
  card1_title_text: {
    id: 'XBEqAo',
    defaultMessage: "Here's what worked for other clients:",
  },
  card2_title_text: {
    id: 'jwfd9k',
    defaultMessage: "Here's how you can drive business results:",
  },
  card3_title_text: {
    id: '8APTb5',
    defaultMessage: 'See it yourself:',
  },
  card4_title_text: {
    id: 'W4YTSo',
    defaultMessage: 'Deep dive into the topic:',
  },
  back_btn: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  next_btn: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  close_btn: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  start_btn_text: {
    id: '+pRm+6',
    defaultMessage: 'Take assessment',
  },
  welcome_info: {
    id: 'Piym33',
    defaultMessage:
      'Don’t know where to start? Try our quick guide to discover tailored content for your industry and business challenges.',
  },
  banner_heading: {
    id: 'gMXo/e',
    defaultMessage: 'Find tailored content in seconds',
  },
  banner_sub_heading: {
    id: '22wzQa',
    defaultMessage:
      'See how Maximo can help address your unique operations needs. Complete the 3-question assessment to get personalized content.',
  },
});

export default messages;
